module.exports = __webpack_public_path__ + "img/imageLandingPreviewOrganizeDevice@1x.edc23c28.png";